import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import Swal from 'sweetalert2';
import ContainerDefault from '../../components/ContainerDefault';
import { Loading } from '../../components/UtilComponent';
import * as agricultorAction from '../../services/agricultor/Action';
import * as balancaAction from '../../services/balanca/Action';
import * as motoristaAction from '../../services/motorista/Action';
import * as pesagemAction from '../../services/pesagem/Action';
import * as produtoAction from '../../services/produto/Action';
import * as tipoPagamentoAction from '../../services/tipo_pagamento/Action';
import * as tipoServicoAction from '../../services/tipo_servico/Action';
import * as Constants from '../../utils/constants';
import * as Utils from '../../utils/utils';
import FormPesagem from './components/FormPesagem';




class PesagemContainer extends Component {

    intervalo = null;
    capturadoPeso = false;


    constructor() {
        super();
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleAddServico = this.handleAddServico.bind(this);
        this.handleChangeStatePesagem = this.handleChangeStatePesagem.bind(this);
        this.handleClickCapturaPesagem = this.handleClickCapturaPesagem.bind(this);
        this.handleDesativarPesagem = this.handleDesativarPesagem.bind(this);

        this.state = {
            servicos: [],
            pesagemState: { id: 0, avulsa: false }
        };

    }

    async componentDidMount() {
        if (this.props.match.params.id) {
            await this.props.action.getPesagemByIdAction(this.props.match.params.id);

            this.setState({
                pesagemState: this.props.pesagemObject
            });
            if (this.state.pesagemState.servicos && this.state.pesagemState.servicos.length > 0) {
                let total = 0;
                this.state.pesagemState.servicos.map((s) => total += parseFloat(s.valor_total) + (s.valor_adicional ? parseFloat(s.valor_adicional) : 0));
                this.handleChangeStatePesagem('valorTotalPesagem', total)
                this.handleChangeStatePesagem('valorTotalServicos', total)

            }
            console.log(this.state.pesagemState)
            this.handleChangeStatePesagem('data_saida', new Date())

        } else {
            this.handleChangeStatePesagem('data_entrada', new Date())
        }



        this.props.action.getMotoristasAction(true);
        this.props.action.getTiposServicosAction();
        this.props.action.getAgricultoresAction(true);
        this.props.action.getProdutosFullAction();
        this.props.action.getTiposPagamentosAction();

        const { action } = this.props;

        this.intervalo = setInterval(function () {
            action.getLeituraAction();
        }, 1800);

    }

    

    async  handleClickCapturaPesagem() {
        await clearInterval(this.intervalo);
        let valor = 0
        if (this.props.balancaObject)
            valor = this.props.balancaObject.results


        Swal.fire({
            position: 'top-end',
            width: '20rem',
            text: ` Pesagem capturada com sucesso! ${Utils.formatarValorNormal(valor)} Kg`,
            showConfirmButton: false,
            timer: 1500
        })
        this.capturadoPeso = true;

    }

    handleAddServico(servico) {
        this.setState(
            this.state.servicos.push(servico)
        );
    }

    handleDesativarPesagem(id) {
        this.props.action.desativarPesagemByIdAction(id).then((id) => {
            this.props.history.push(Constants.ROUTE_URL_PESAGENS);

        });
    }

    handleChangeStatePesagem(nome, valor) {
        this.setState(prevState => ({
            pesagemState: {
                ...prevState.pesagemState,
                [nome]: valor
            }
        }), () => {
            this.props.action.atualizarPesagemObject(this.state.pesagemState);
        });
    }

    handleCancel(event) {
        this.props.history.replace(Constants.ROUTE_URL_PESAGENS);

    }

    handlePesoInvalido(peso) {
        if (!peso || peso <= 0) {
            Swal.fire({
                title: "Ops",
                text: `O peso está inválido com valor 0. Realize uma nova captura. Obrigado!`,
                icon: "error",
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Sim, irei realizar!',
                dangerMode: true,
            });
            const { action } = this.props;
            this.intervalo = setInterval(function () {
                action.getLeituraAction();
            }, 1800);

            throw new SubmissionError({ 'peso_capturado': 'O peso está inválido com valor 0. Realize uma nova captura. Obrigado! ' });
            // return;
        }

    }

    componentWillUnmount() {
        clearInterval(this.intervalo);
        this.props.action.atualizarPesagemObject(null);
    }
    async atualizarDados(values) {
        const { balancaObject, messages } = await this.props;

        if (!this.capturadoPeso && !this.state.pesagemState.avulsa)
            this.handleClickCapturaPesagem()

        if (this.state.pesagemState.id) {
            // values.data_saida = moment(values.data_saida).utc().format();
            values.peso_saida = balancaObject ? balancaObject.results : 0;
            this.handlePesoInvalido(values.peso_saida)
            values.peso_balanca_saida = values.peso;
            values.peso_liquido = Math.abs(values.peso_saida - values.peso);
            values.tipo_pagamento = (this.state.pesagemState.tipo_pagamento) ? this.state.pesagemState.tipo_pagamento.id : null;
            values.usuario_pesagem_entrada = (this.state.pesagemState.usuario_pesagem_entrada) ? this.state.pesagemState.usuario_pesagem_entrada.id : null;
        } else {
            if (!this.state.pesagemState.servicos) {

                throw new SubmissionError({ 'tipoServico': 'Adicione pelo menos um serviço.' });
            }
            // values.data_entrada = moment(values.data_entrada).utc().format();
            values.is_avulsa = this.state.pesagemState.avulsa ? 'True': 'False'
            if (!this.state.pesagemState.avulsa){
                values.peso = balancaObject ? balancaObject.results : 0;
            }
            this.handlePesoInvalido(values.peso)
            values.peso_balanca = values.peso;
            values.peso_liquido = values.peso;
            values.tipo_pagamento = (this.state.pesagemState.tipoPagamento) ? this.state.pesagemState.tipoPagamento.id : null;

            values.valor_pago = (this.state.pesagemState.valorPago) ? this.state.pesagemState.valorPago : 0;

            values.valor_total = (this.state.pesagemState.valorTotalPesagem) ? this.state.pesagemState.valorTotalPesagem : 0;
            values.valor_desconto = (this.state.pesagemState.valorDesconto) ? this.state.pesagemState.valorDesconto : 0;
            values.valor_adicional = (this.state.pesagemState.valorAdicionalPesagem) ? this.state.pesagemState.valorAdicionalPesagem : 0;
            values.valor_troco = (this.state.pesagemState.valorTroco) ? this.state.pesagemState.valorTroco : 0;
            if (parseFloat(values.valor_total) > parseFloat(values.valor_pago)) {
                throw new SubmissionError({ 'valorPago': 'O valor está abaixo do valor total.' });
            }
        }
        values.tipo = this.state.pesagemState.id ? 'SAIDA' : 'ENTRADA';
        values.agricultor = (this.state.pesagemState.agricultor) ? this.state.pesagemState.agricultor.id : 0;
        values.produto = (this.state.pesagemState.produto) ? this.state.pesagemState.produto.id : "";
        values.motorista = (this.state.pesagemState.motorista) ? this.state.pesagemState.motorista.id : "";


        values.servicos = (this.state.pesagemState.servicos) ? this.state.pesagemState.servicos : "";
        values.servicos = await this.state.pesagemState.servicos;


        return values
    }
    async handleSave(values) {

        values = await this.atualizarDados(values)
        try {
            var pesagemObject = await this.props.action.savePesagemAction(values);
            if (pesagemObject) {
                let page = '/resumo-pesagem/' + pesagemObject.id
                this.props.history.push(page)
            }
        } catch (error) {
            throw new SubmissionError(error);
        };


    }
    retornarDadosTela() {
        const { pesagemObject, messages, messageSuccess, isLoading, motoristaObject, agricultorObject, produtoObject, tipoServicoObject, tipoPagamentoObject, balancaObject } = this.props;

        if (isLoading) return (
            <Loading title={Constants.DESCRICAO_PESAGEM} />
        );

        return (<ContainerDefault
            title={Constants.DESCRICAO_PESAGEM}
            messages={messages}
            messageSuccess={messageSuccess}
            container={
                <FormPesagem
                    motoristas={motoristaObject ? motoristaObject.results : []}
                    agricultores={agricultorObject ? agricultorObject.results : []}
                    produtos={produtoObject ? produtoObject.results : []}
                    tiposServicos={tipoServicoObject ? tipoServicoObject.results : []}
                    tiposPagamentos={tipoPagamentoObject ? tipoPagamentoObject.results : []}
                    leitura={balancaObject ? balancaObject.results : []}
                    initialValues={pesagemObject}
                    handleChangeStatePesagem={this.handleChangeStatePesagem}
                    pesagemState={this.state.pesagemState}
                    handleSave={this.handleSave}
                    handleCancel={this.handleCancel}
                    handleClickCapturaPesagem={this.handleClickCapturaPesagem}
                    handleDesativarPesagem={this.handleDesativarPesagem}
                    heading={'Adicionar'}
                />
            } />);

    }

    render() {
        return this.retornarDadosTela();
    }
}


const mapStateToProps = state => ({

    pesagemObject: state.pesagemReducer.pesagemObject,
    messages: state.messageResponseReducer.messages,
    messageSuccess: state.messageResponseReducer.messageSuccess,
    isLoading: state.apiReducer.isLoading,
    motoristaObject: state.motoristaReducer.motoristaObject,
    agricultorObject: state.agricultorReducer.agricultorObject,
    produtoObject: state.produtoReducer.produtoObject,
    tipoServicoObject: state.tipoServicoReducer.tipoServicoObject,
    tipoPagamentoObject: state.tipoPagamentoReducer.tipoPagamentoObject,
    balancaObject: state.balancaReducer.balancaObject

})


const mapDispatchToProps = dispatch => ({

    action: bindActionCreators({ ...pesagemAction, ...motoristaAction, ...agricultorAction, ...produtoAction, ...tipoServicoAction, ...tipoPagamentoAction, ...balancaAction }, dispatch)

});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PesagemContainer));
